import { Button } from "design-system/atoms/Button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "design-system/atoms/Dialog"
import { useSidebar } from "design-system/organisms/Sidebar"
import { HUBSPOT_DEMO_URL } from "lopermut"
import { CalendarDays } from "lucide-react"
import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import { canSeeSubscription } from "modules/subscription/lib/canSeeSubscription"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { OrganizationTypeEnum, hasBackofficeAccess } from "schema"

export function BookDemoButton() {
  const { t } = useTranslation()
  const { state, isMobile } = useSidebar()
  const { data: employee } = useAuthEmployeeQuery()
  const [isOpen, setIsOpen] = useState(false)

  if (
    !employee ||
    !canSeeSubscription(employee) ||
    employee.organization.type !== OrganizationTypeEnum.Freemium ||
    hasBackofficeAccess(employee.backofficeType)
  ) {
    return null
  }

  const isExpanded = state === "expanded" || isMobile

  return (
    <>
      <div className="px-2 pb-2">
        <Button
          variant="default"
          onClick={() => setIsOpen(true)}
          className="h-10 font-normal gap-3 w-full justify-start px-5"
        >
          <CalendarDays className="h-4 w-4 shrink-0" />
          {isExpanded && <span>{t("subscription.bookDemo.button")}</span>}
        </Button>
      </div>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="sm:max-w-2xl p-0 overflow-hidden">
          <DialogHeader className="px-6 pt-6 pb-0">
            <DialogTitle>{t("subscription.bookDemo.title")}</DialogTitle>
          </DialogHeader>
          <iframe
            src={HUBSPOT_DEMO_URL}
            className="w-full h-[700px] border-0"
            title={t("subscription.bookDemo.title")}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
